import React, { useContext, useRef, useState, useEffect } from "react";
import { debounce } from "lodash";
import LogicContext from "../Context/LogicContext";
import { customerService } from "../services/customer.service";
import { CheckIcon, MagnifyingGlassIcon } from "@heroicons/react/20/solid";

function GeneralCustomerSearch(props) {
  const logicContext = useContext(LogicContext);
  const [textInput, setTextInput] = useState(props?.defaultVal || "");
  const [searchResult, setSearchResult] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const isMounted = useRef(true);

  useEffect(() => {
    isMounted.current = true;
    return () => {
      isMounted.current = false;
    };
  }, []);

  const debouncedSearch = useRef(
    debounce(async (search) => {
      processSearch(search);
    }, 1000)
  ).current;

  function processSearch(search) {
    if (search?.length > 2) {
      customerService.getCustomerBySearch(search).then((res) => {
        if (isMounted.current) {
          if (res?.data?.length) {
            setSearchResult(res?.data);
            setIsOpen(true);
          } else {
            logicContext.showToast("No available record for your search query!", "error");
            setSearchResult([]);
            setIsOpen(false);
          }
        }
      });
    } else {
      setSearchResult([]);
      setIsOpen(false);
    }
  }

  const handleSelect = (customer) => {
    props.onCustomerSelect(customer);
    setTextInput(customer.Name);
    setIsOpen(false);
  };

  return (
    <div className="relative w-full max-w-lg">
      {/* Input Box */}
      <div className="relative">
        <input
          type="text"
          className="w-full px-4 py-2 pl-10 rounded-xl text-sm border border-gray-300 shadow-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none"
          placeholder="Search customer..."
          value={textInput}
          onChange={(e) => {
            setTextInput(e.target.value);
            debouncedSearch(e.target.value);
          }}
          onFocus={() => searchResult.length > 0 && setIsOpen(true)}
        />
        <MagnifyingGlassIcon className="absolute left-3 top-2.5 h-5 w-5 text-gray-400" />
      </div>

      {/* Dropdown */}
      {isOpen && (
        <div className="absolute z-20 mt-2 w-full bg-white shadow-xl rounded-xl border border-gray-200 max-h-64 overflow-auto">
          {searchResult.length === 0 ? (
            <div className="px-4 py-3 text-sm text-gray-500">No results found.</div>
          ) : (
            searchResult.map((customer, index) => (
              <div
                key={index}
                onClick={() => handleSelect(customer)}
                className="px-4 py-3 cursor-pointer rounded-lg flex items-center justify-between 
                hover:bg-blue-50 transition-all border-2"
              >
                <div className="flex flex-col">
                  <span className="font-medium text-gray-800">{customer.Name}</span>
                  <span className="text-xs text-gray-500">{customer.Email_Address}</span>
                  <span className="text-xs text-gray-500">{customer.Mobile}</span>
                </div>

                <CheckIcon
                  className={`h-5 w-5 text-blue-500 ${
                    textInput === customer.Name ? "opacity-100" : "opacity-0"
                  } transition`}
                />
              </div>
            ))
          )}
        </div>
      )}
    </div>
  );
}

export default GeneralCustomerSearch;
